import CreateFantacyMatch from './CreateFantacyMatch';

export default CreateFantacyMatch;